/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiKeyListResponse } from '../model';
// @ts-ignore
import { ApiKeyRequest } from '../model';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { NewApiKeyResponse } from '../model';
/**
 * APIKeyApi - axios parameter creator
 * @export
 */
export const APIKeyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This generates a new API key. This API key value is not retrievable.
         * @summary Generates API Key
         * @param {ApiKeyRequest} apiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateApiKey: async (apiKeyRequest: ApiKeyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyRequest' is not null or undefined
            assertParamExists('generateApiKey', 'apiKeyRequest', apiKeyRequest)
            const localVarPath = `/v1/entity/organization/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = apiKeyRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns API keys. This is a temporary feature. Eventually, this is going to return a list of objects that have `created_at`, `is_active`, etc.
         * @summary Gets API Keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeys: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/organization/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This revokes an existing API key.
         * @summary Revokes API key
         * @param {string} id API key ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeApiKey: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('revokeApiKey', 'id', id)
            const localVarPath = `/v1/entity/organization/api-keys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * APIKeyApi - functional programming interface
 * @export
 */
export const APIKeyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = APIKeyApiAxiosParamCreator(configuration)
    return {
        /**
         * This generates a new API key. This API key value is not retrievable.
         * @summary Generates API Key
         * @param {ApiKeyRequest} apiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateApiKey(apiKeyRequest: ApiKeyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewApiKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateApiKey(apiKeyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns API keys. This is a temporary feature. Eventually, this is going to return a list of objects that have `created_at`, `is_active`, etc.
         * @summary Gets API Keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiKeys(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This revokes an existing API key.
         * @summary Revokes API key
         * @param {string} id API key ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeApiKey(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeApiKey(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * APIKeyApi - factory interface
 * @export
 */
export const APIKeyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = APIKeyApiFp(configuration)
    return {
        /**
         * This generates a new API key. This API key value is not retrievable.
         * @summary Generates API Key
         * @param {ApiKeyRequest} apiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateApiKey(apiKeyRequest: ApiKeyRequest, options?: any): AxiosPromise<NewApiKeyResponse> {
            return localVarFp.generateApiKey(apiKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns API keys. This is a temporary feature. Eventually, this is going to return a list of objects that have `created_at`, `is_active`, etc.
         * @summary Gets API Keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeys(options?: any): AxiosPromise<ApiKeyListResponse> {
            return localVarFp.getApiKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * This revokes an existing API key.
         * @summary Revokes API key
         * @param {string} id API key ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeApiKey(id: string, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.revokeApiKey(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * APIKeyApi - interface
 * @export
 * @interface APIKeyApi
 */
export interface APIKeyApiInterface {
    /**
     * This generates a new API key. This API key value is not retrievable.
     * @summary Generates API Key
     * @param {ApiKeyRequest} apiKeyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeyApiInterface
     */
    generateApiKey(apiKeyRequest: ApiKeyRequest, options?: AxiosRequestConfig): AxiosPromise<NewApiKeyResponse>;

    /**
     * This returns API keys. This is a temporary feature. Eventually, this is going to return a list of objects that have `created_at`, `is_active`, etc.
     * @summary Gets API Keys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeyApiInterface
     */
    getApiKeys(options?: AxiosRequestConfig): AxiosPromise<ApiKeyListResponse>;

    /**
     * This revokes an existing API key.
     * @summary Revokes API key
     * @param {string} id API key ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeyApiInterface
     */
    revokeApiKey(id: string, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

}

/**
 * APIKeyApi - object-oriented interface
 * @export
 * @class APIKeyApi
 * @extends {BaseAPI}
 */
export class APIKeyApi extends BaseAPI implements APIKeyApiInterface {
    /**
     * This generates a new API key. This API key value is not retrievable.
     * @summary Generates API Key
     * @param {ApiKeyRequest} apiKeyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeyApi
     */
    public generateApiKey(apiKeyRequest: ApiKeyRequest, options?: AxiosRequestConfig) {
        return APIKeyApiFp(this.configuration).generateApiKey(apiKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns API keys. This is a temporary feature. Eventually, this is going to return a list of objects that have `created_at`, `is_active`, etc.
     * @summary Gets API Keys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeyApi
     */
    public getApiKeys(options?: AxiosRequestConfig) {
        return APIKeyApiFp(this.configuration).getApiKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This revokes an existing API key.
     * @summary Revokes API key
     * @param {string} id API key ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeyApi
     */
    public revokeApiKey(id: string, options?: AxiosRequestConfig) {
        return APIKeyApiFp(this.configuration).revokeApiKey(id, options).then((request) => request(this.axios, this.basePath));
    }
}
